import {
    TableCell, tableCellClasses, TableRow, styled, Box,
    IconButton, Collapse, Table, TableHead, TableBody
} from "@mui/material";
import { FC, useState } from "react";
import { EditCout, PivotDatas } from "./AddCoutForm";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { cellStyle } from "../../content/parametrage/Pays/RowPays";
import EachRowInAssociation from "./EachRowInAssociation";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#080d44',
        color: theme.palette.common.white,
        textAlign: 'center',
        fontSize: 11
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textAlign: 'center'
    },
}));

interface AddCoutRowFormProps {
    association: PivotDatas;
    handleChangeCout: (editCout: EditCout) => void;
};

const AddCoutRowForm: FC<AddCoutRowFormProps> = ({ association, handleChangeCout }) => {
    const [open, setOpen] = useState<boolean>(true);
    
    return (
        <>
            <TableRow>
                <TableCell align="left">
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                        sx={{ fontSize: 12 }}
                    >
                        {open ? (
                            <KeyboardArrowUpIcon />
                        ) : (
                            <KeyboardArrowDownIcon />
                        )}
                    </IconButton>
                    {association?.societe_fact?.libelle}
                </TableCell>
                <TableCell align="left">
                    {association?.code_gesco?.libelle}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={cellStyle} colSpan={2}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>
                                            Code article
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Désignation
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Cout activité
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Devise
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Date début
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Date fin
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        association?.articles?.map((article) => (
                                            <EachRowInAssociation
                                                key={article?.id}
                                                article={article}
                                                handleChangeCout={handleChangeCout}
                                            />
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default AddCoutRowForm;